import { render } from "./RutinasView.vue?vue&type=template&id=ca8837d4"
import script from "./RutinasView.vue?vue&type=script&lang=js"
export * from "./RutinasView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__